/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 구독 정보 응답
 * @export
 * @interface SubscriptionResponse
 */
export interface SubscriptionResponse {
    /**
     * 구독 ID
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'id'?: string;
    /**
     * 주문 ID
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'orderId'?: string;
    /**
     * 사용자 ID
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'userId'?: string;
    /**
     * 상품명
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'productName'?: string;
    /**
     * 결제 금액
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'amount'?: string;
    /**
     * 구독 상태
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'status'?: SubscriptionResponseStatusEnum;
    /**
     * 다음 결제일
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'nextBillingDate'?: string | null;
    /**
     * 마지막 결제일
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'lastPaymentDate'?: string | null;
    /**
     * 구독 시작일
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'startDate'?: string | null;
    /**
     * 구독 종료일
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'endDate'?: string | null;
    /**
     * 마지막 결제 결과
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'lastPaymentResult'?: string | null;
    /**
     * 카드명 (마스킹된 정보)
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'cardName'?: string | null;
    /**
     * 생성일시
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'createdAt'?: string;
    /**
     * 수정일시
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'updatedAt'?: string;
}

export const SubscriptionResponseStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Cancelled: 'CANCELLED',
    Expired: 'EXPIRED',
    PendingBillingKey: 'PENDING_BILLING_KEY',
    PaymentFailure: 'PAYMENT_FAILURE',
    CanceledByUser: 'CANCELED_BY_USER',
    CanceledByAdmin: 'CANCELED_BY_ADMIN',
    OnHold: 'ON_HOLD',
    RegistrationFailure: 'REGISTRATION_FAILURE',
    Superseded: 'SUPERSEDED'
} as const;

export type SubscriptionResponseStatusEnum = typeof SubscriptionResponseStatusEnum[keyof typeof SubscriptionResponseStatusEnum];


